/**
 * US-friendly time zone options for dropdowns.
 * Value is IANA time zone (e.g. America/New_York) for API/date logic;
 * label is the human-readable name (e.g. Eastern Time).
 */
export const TIME_ZONE_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "Select time zone" },
  { value: "America/New_York", label: "Eastern Time" },
  { value: "America/Chicago", label: "Central Time" },
  { value: "America/Denver", label: "Mountain Time" },
  { value: "America/Los_Angeles", label: "Pacific Time" },
  { value: "America/Anchorage", label: "Alaska Time" },
  { value: "Pacific/Honolulu", label: "Hawaii-Aleutian Time" },
  { value: "America/Phoenix", label: "Arizona (no DST)" },
  { value: "America/Detroit", label: "Eastern Time (Detroit)" },
  { value: "America/Indiana/Indianapolis", label: "Eastern Time (Indiana)" },
];

/**
 * Curated display name from account settings options (e.g. "Pacific Time"), or null if unknown.
 */
export function getCuratedTimeZoneLabel(
  iana: string | null | undefined,
): string | null {
  if (iana == null || iana === "") return null;
  const option = TIME_ZONE_OPTIONS.find((opt) => opt.value === iana);
  return option ? option.label : null;
}

/**
 * Returns the friendly label for an IANA time zone, or the raw value if not in the list.
 */
export function getTimeZoneLabel(iana: string | null | undefined): string {
  const curated = getCuratedTimeZoneLabel(iana);
  if (curated) return curated;
  if (iana == null || iana === "") return "";
  return iana;
}
